
import { RevLink, openModal } from '@backmarket/design-system'

import { MODAL_NAMES } from '@config/constants'
import { trackClick } from '@tracking/events'

import HighlightedPickersList from '../HighlightedPickersList'
import HighlightedPickersModal from '../Modals/HighlightedPickersModal'

import translations from './HighlightedPickers.translations'

export default {
  components: {
    RevLink,
    HighlightedPickersList,
    HighlightedPickersModal,
  },
  props: {
    highlightedPickers: {
      type: Array,
      default: () => [],
    },
    selectedHighlightedPickers: {
      type: Object,
      default: null,
    },
  },
  computed: {
    translations: () => translations,
  },
  methods: {
    handleModalOpen() {
      openModal(MODAL_NAMES.PRODUCT.HIGHLIGHTED_PICKERS)
    },

    handlePickersClick(index) {
      trackClick({
        name: this.highlightedPickers[index].id,
        zone: 'master_picker',
      })
    },
  },
}
